import * as React from "react";
import styled, { css } from "styled-components";
import { Icon, Tooltip } from "components/common";
import useStreamDataLakeConfig from "data-lake/hooks/useStreamDataLakeConfig";
const Wrapper = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.variant.warning};
  `
);
const StreamIndexSetDataLakeWarning = ({ streamId, isArchivingEnabled }) => {
  const { data, isFetching, isError } = useStreamDataLakeConfig(streamId);
  if (!isArchivingEnabled || isFetching || isError || !(data == null ? void 0 : data.enabled)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Tooltip, { withArrow: true, position: "top", label: "Using Archiving and Data Lake together increases storage requirement." }, /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Icon, { name: "report" })));
};
export default StreamIndexSetDataLakeWarning;
